import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _4e0d484a = () => interopDefault(import('../pages/autofix-installation/index.vue' /* webpackChunkName: "pages/autofix-installation/index" */))
const _e90e84be = () => interopDefault(import('../pages/control-panel/index.vue' /* webpackChunkName: "pages/control-panel/index" */))
const _b29fe0c4 = () => interopDefault(import('../pages/dashboard.vue' /* webpackChunkName: "pages/dashboard" */))
const _42a5efc2 = () => interopDefault(import('../pages/health.vue' /* webpackChunkName: "pages/health" */))
const _17f16eba = () => interopDefault(import('../pages/installation/index.vue' /* webpackChunkName: "pages/installation/index" */))
const _ed51da7c = () => interopDefault(import('../pages/invitation/index.vue' /* webpackChunkName: "pages/invitation/index" */))
const _0645ef36 = () => interopDefault(import('../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _03a11b4b = () => interopDefault(import('../pages/request-access/index.vue' /* webpackChunkName: "pages/request-access/index" */))
const _70d47289 = () => interopDefault(import('../pages/settings.vue' /* webpackChunkName: "pages/settings" */))
const _b7b00cb2 = () => interopDefault(import('../pages/settings/account.vue' /* webpackChunkName: "pages/settings/account" */))
const _4dc768e0 = () => interopDefault(import('../pages/settings/tokens.vue' /* webpackChunkName: "pages/settings/tokens" */))
const _1fb2fb74 = () => interopDefault(import('../pages/settings/workspaces.vue' /* webpackChunkName: "pages/settings/workspaces" */))
const _623b839c = () => interopDefault(import('../pages/support/index.vue' /* webpackChunkName: "pages/support/index" */))
const _04a8550f = () => interopDefault(import('../pages/team-deleted.vue' /* webpackChunkName: "pages/team-deleted" */))
const _0040497d = () => interopDefault(import('../pages/user-deleted.vue' /* webpackChunkName: "pages/user-deleted" */))
const _499124c6 = () => interopDefault(import('../pages/cli/auth.vue' /* webpackChunkName: "pages/cli/auth" */))
const _27eb7b5a = () => interopDefault(import('../pages/control-panel/license/index.vue' /* webpackChunkName: "pages/control-panel/license/index" */))
const _96fee4d2 = () => interopDefault(import('../pages/control-panel/user-management/index.vue' /* webpackChunkName: "pages/control-panel/user-management/index" */))
const _ddd4195a = () => interopDefault(import('../pages/ide/auth.vue' /* webpackChunkName: "pages/ide/auth" */))
const _e5c6a81a = () => interopDefault(import('../pages/installation/providers.vue' /* webpackChunkName: "pages/installation/providers" */))
const _5341c90a = () => interopDefault(import('../pages/oauth/authorize.vue' /* webpackChunkName: "pages/oauth/authorize" */))
const _bae3e9ce = () => interopDefault(import('../pages/onboard/bitbucket.vue' /* webpackChunkName: "pages/onboard/bitbucket" */))
const _0fa7d58a = () => interopDefault(import('../pages/accounts/ads/login/index.vue' /* webpackChunkName: "pages/accounts/ads/login/index" */))
const _cb8b1e04 = () => interopDefault(import('../pages/accounts/bbd/login/index.vue' /* webpackChunkName: "pages/accounts/bbd/login/index" */))
const _7d8ee568 = () => interopDefault(import('../pages/accounts/gitlab/login.vue' /* webpackChunkName: "pages/accounts/gitlab/login" */))
const _587d69ba = () => interopDefault(import('../pages/callback/integrations/jira.vue' /* webpackChunkName: "pages/callback/integrations/jira" */))
const _aed43b98 = () => interopDefault(import('../pages/callback/integrations/slack.vue' /* webpackChunkName: "pages/callback/integrations/slack" */))
const _8a468918 = () => interopDefault(import('../pages/callback/integrations/vanta.vue' /* webpackChunkName: "pages/callback/integrations/vanta" */))
const _071abfbc = () => interopDefault(import('../pages/control-panel/user-management/groups/index.vue' /* webpackChunkName: "pages/control-panel/user-management/groups/index" */))
const _2cdf640f = () => interopDefault(import('../pages/control-panel/user-management/invites.vue' /* webpackChunkName: "pages/control-panel/user-management/invites" */))
const _cd0e6500 = () => interopDefault(import('../pages/team/settings/integrations/vanta.vue' /* webpackChunkName: "pages/team/settings/integrations/vanta" */))
const _05b430d4 = () => interopDefault(import('../pages/auth/-index.vue' /* webpackChunkName: "pages/auth" */))
const _9121f048 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _572b7436 = () => interopDefault(import('../pages/accounts/ads/login/_login/index.vue' /* webpackChunkName: "pages/accounts/ads/login/_login/index" */))
const _158a6d5e = () => interopDefault(import('../pages/control-panel/user-management/groups/_groupId/index.vue' /* webpackChunkName: "pages/control-panel/user-management/groups/_groupId/index" */))
const _5b4d5066 = () => interopDefault(import('../pages/control-panel/user-management/users/_userId/index.vue' /* webpackChunkName: "pages/control-panel/user-management/users/_userId/index" */))
const _3c3e3c42 = () => interopDefault(import('../pages/control-panel/user-management/groups/_groupId/teams.vue' /* webpackChunkName: "pages/control-panel/user-management/groups/_groupId/teams" */))
const _fbfdc16c = () => interopDefault(import('../pages/control-panel/user-management/users/_userId/teams.vue' /* webpackChunkName: "pages/control-panel/user-management/users/_userId/teams" */))
const _258eedd7 = () => interopDefault(import('../pages/groups/invite/_inviteCode/index.vue' /* webpackChunkName: "pages/groups/invite/_inviteCode/index" */))
const _039fad64 = () => interopDefault(import('../pages/installation/_provider/index.vue' /* webpackChunkName: "pages/installation/_provider/index" */))
const _3a638d3f = () => interopDefault(import('../pages/invitation/_code/index.vue' /* webpackChunkName: "pages/invitation/_code/index" */))
const _eba907ce = () => interopDefault(import('../pages/report/_reportId.vue' /* webpackChunkName: "pages/report/_reportId" */))
const _605d6b28 = () => interopDefault(import('../pages/report/_reportId/active-third-party-vulnerabilities.vue' /* webpackChunkName: "pages/report/_reportId/active-third-party-vulnerabilities" */))
const _78ab685c = () => interopDefault(import('../pages/report/_reportId/code-coverage.vue' /* webpackChunkName: "pages/report/_reportId/code-coverage" */))
const _70669dd6 = () => interopDefault(import('../pages/report/_reportId/code-health-trend.vue' /* webpackChunkName: "pages/report/_reportId/code-health-trend" */))
const _67862d44 = () => interopDefault(import('../pages/report/_reportId/issue-distribution.vue' /* webpackChunkName: "pages/report/_reportId/issue-distribution" */))
const _5c89c8b8 = () => interopDefault(import('../pages/report/_reportId/issues-autofixed.vue' /* webpackChunkName: "pages/report/_reportId/issues-autofixed" */))
const _597345ec = () => interopDefault(import('../pages/report/_reportId/issues-prevented.vue' /* webpackChunkName: "pages/report/_reportId/issues-prevented" */))
const _392e7eb4 = () => interopDefault(import('../pages/report/_reportId/misra-c.vue' /* webpackChunkName: "pages/report/_reportId/misra-c" */))
const _2102e194 = () => interopDefault(import('../pages/report/_reportId/owasp-top-10.vue' /* webpackChunkName: "pages/report/_reportId/owasp-top-10" */))
const _afaf8782 = () => interopDefault(import('../pages/report/_reportId/sans-top-25.vue' /* webpackChunkName: "pages/report/_reportId/sans-top-25" */))
const _7aecaad0 = () => interopDefault(import('../pages/report/_reportId/sca-targets.vue' /* webpackChunkName: "pages/report/_reportId/sca-targets" */))
const _7cda7050 = () => interopDefault(import('../pages/invitation/_code/confirmation.vue' /* webpackChunkName: "pages/invitation/_code/confirmation" */))
const _1f6d473e = () => interopDefault(import('../pages/onboard/_provider/_owner.vue' /* webpackChunkName: "pages/onboard/_provider/_owner" */))
const _b1630eb2 = () => interopDefault(import('../pages/onboard/_provider/_owner/invite.vue' /* webpackChunkName: "pages/onboard/_provider/_owner/invite" */))
const _3e744eed = () => interopDefault(import('../pages/onboard/_provider/_owner/personal-info.vue' /* webpackChunkName: "pages/onboard/_provider/_owner/personal-info" */))
const _380a7210 = () => interopDefault(import('../pages/onboard/_provider/_owner/repo.vue' /* webpackChunkName: "pages/onboard/_provider/_owner/repo" */))
const _fc6e9362 = () => interopDefault(import('../pages/onboard/_provider/_owner/use-cases.vue' /* webpackChunkName: "pages/onboard/_provider/_owner/use-cases" */))
const _7cc6f6a1 = () => interopDefault(import('../pages/onboard/_provider/_owner/_repo/analyzers.vue' /* webpackChunkName: "pages/onboard/_provider/_owner/_repo/analyzers" */))
const _7968669f = () => interopDefault(import('../pages/onboard/_provider/_owner/_repo/run.vue' /* webpackChunkName: "pages/onboard/_provider/_owner/_repo/run" */))
const _14fdb032 = () => interopDefault(import('../pages/orgs/_provider/_owner/members.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/members" */))
const _71d65844 = () => interopDefault(import('../pages/orgs/_provider/_owner/members/active.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/members/active" */))
const _0367c253 = () => interopDefault(import('../pages/orgs/_provider/_owner/members/invited.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/members/invited" */))
const _e42c54c8 = () => interopDefault(import('../pages/orgs/_provider/_owner/members/requests.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/members/requests" */))
const _07aa9c1c = () => interopDefault(import('../pages/orgs/_provider/_owner/policies.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/policies" */))
const _066c53d6 = () => interopDefault(import('../pages/orgs/_provider/_owner/policies/ai.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/policies/ai" */))
const _40381cca = () => interopDefault(import('../pages/orgs/_provider/_owner/policies/dynamic-risk.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/policies/dynamic-risk" */))
const _ba5e04d8 = () => interopDefault(import('../pages/orgs/_provider/_owner/policies/license-compliance.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/policies/license-compliance" */))
const _74328d41 = () => interopDefault(import('../pages/orgs/_provider/_owner/policies/sca-vulnerabilities.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/policies/sca-vulnerabilities" */))
const _d76024e6 = () => interopDefault(import('../pages/orgs/_provider/_owner/reports.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/reports" */))
const _d46bde0a = () => interopDefault(import('../pages/orgs/_provider/_owner/reports/active-third-party-vulnerabilities/index.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/reports/active-third-party-vulnerabilities/index" */))
const _dbff476e = () => interopDefault(import('../pages/orgs/_provider/_owner/reports/code-coverage/index.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/reports/code-coverage/index" */))
const _bef97d66 = () => interopDefault(import('../pages/orgs/_provider/_owner/reports/code-health-trend/index.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/reports/code-health-trend/index" */))
const _6606ca6d = () => interopDefault(import('../pages/orgs/_provider/_owner/reports/issue-distribution/index.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/reports/issue-distribution/index" */))
const _9107dd72 = () => interopDefault(import('../pages/orgs/_provider/_owner/reports/issues-autofixed/index.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/reports/issues-autofixed/index" */))
const _3d38a019 = () => interopDefault(import('../pages/orgs/_provider/_owner/reports/issues-prevented/index.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/reports/issues-prevented/index" */))
const _6132edc6 = () => interopDefault(import('../pages/orgs/_provider/_owner/reports/misra-c/index.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/reports/misra-c/index" */))
const _1acdfb23 = () => interopDefault(import('../pages/orgs/_provider/_owner/reports/owasp-top-10/index.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/reports/owasp-top-10/index" */))
const _41bc2310 = () => interopDefault(import('../pages/orgs/_provider/_owner/reports/public-reports/index.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/reports/public-reports/index" */))
const _b0025814 = () => interopDefault(import('../pages/orgs/_provider/_owner/reports/sans-top-25/index.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/reports/sans-top-25/index" */))
const _3ba051c7 = () => interopDefault(import('../pages/orgs/_provider/_owner/reports/sca-targets/index.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/reports/sca-targets/index" */))
const _d97f9a40 = () => interopDefault(import('../pages/orgs/_provider/_owner/reports/misra-c/_tag.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/reports/misra-c/_tag" */))
const _50812fcc = () => interopDefault(import('../pages/orgs/_provider/_owner/reports/owasp-top-10/_tag.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/reports/owasp-top-10/_tag" */))
const _fd12ae32 = () => interopDefault(import('../pages/orgs/_provider/_owner/reports/sans-top-25/_tag.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/reports/sans-top-25/_tag" */))
const _6fb3d38f = () => interopDefault(import('../pages/orgs/_provider/_owner/repos.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/repos" */))
const _00b132d2 = () => interopDefault(import('../pages/orgs/_provider/_owner/repos/index.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/repos/index" */))
const _39097f04 = () => interopDefault(import('../pages/orgs/_provider/_owner/repos/groups.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/repos/groups" */))
const _8d5b6eaa = () => interopDefault(import('../pages/orgs/_provider/_owner/repos/_repoType.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/repos/_repoType" */))
const _82864976 = () => interopDefault(import('../pages/orgs/_provider/_owner/settings.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/settings" */))
const _0ea2121e = () => interopDefault(import('../pages/orgs/_provider/_owner/settings/access.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/settings/access" */))
const _82eefef0 = () => interopDefault(import('../pages/orgs/_provider/_owner/settings/audit-log.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/settings/audit-log" */))
const _efa83518 = () => interopDefault(import('../pages/orgs/_provider/_owner/settings/billing/index.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/settings/billing/index" */))
const _3a2b8f9e = () => interopDefault(import('../pages/orgs/_provider/_owner/settings/general.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/settings/general" */))
const _80472ac8 = () => interopDefault(import('../pages/orgs/_provider/_owner/settings/integrations/index.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/settings/integrations/index" */))
const _34dbf50c = () => interopDefault(import('../pages/orgs/_provider/_owner/settings/security.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/settings/security" */))
const _6e88d89a = () => interopDefault(import('../pages/orgs/_provider/_owner/settings/usage/index.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/settings/usage/index" */))
const _7ea73916 = () => interopDefault(import('../pages/orgs/_provider/_owner/settings/webhooks.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/settings/webhooks" */))
const _efa3d1ce = () => interopDefault(import('../pages/orgs/_provider/_owner/settings/webhooks/index.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/settings/webhooks/index" */))
const _1b2003bf = () => interopDefault(import('../pages/orgs/_provider/_owner/settings/webhooks/_webhookId/index.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/settings/webhooks/_webhookId/index" */))
const _b07aaee4 = () => interopDefault(import('../pages/orgs/_provider/_owner/settings/webhooks/_webhookId/log/_logId.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/settings/webhooks/_webhookId/log/_logId" */))
const _9aae54d8 = () => interopDefault(import('../pages/orgs/_provider/_owner/settings/billing/checkout.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/settings/billing/checkout" */))
const _434edcd4 = () => interopDefault(import('../pages/orgs/_provider/_owner/settings/integrations/jira.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/settings/integrations/jira" */))
const _17f2d25a = () => interopDefault(import('../pages/orgs/_provider/_owner/settings/integrations/slack.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/settings/integrations/slack" */))
const _2a39ab9a = () => interopDefault(import('../pages/orgs/_provider/_owner/settings/integrations/vanta.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/settings/integrations/vanta" */))
const _63610cca = () => interopDefault(import('../pages/orgs/_provider/_owner/settings/usage/targets.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/settings/usage/targets" */))
const _12fc82b6 = () => interopDefault(import('../pages/orgs/_provider/_owner/settings/billing/subscribe/_plan.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/settings/billing/subscribe/_plan" */))
const _69e7c834 = () => interopDefault(import('../pages/orgs/_provider/_owner/groups/_groupSlug.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/groups/_groupSlug" */))
const _5cfb5092 = () => interopDefault(import('../pages/orgs/_provider/_owner/groups/_groupSlug/index.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/groups/_groupSlug/index" */))
const _5b8522e4 = () => interopDefault(import('../pages/orgs/_provider/_owner/groups/_groupSlug/reports.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/groups/_groupSlug/reports" */))
const _c0f6ffc0 = () => interopDefault(import('../pages/orgs/_provider/_owner/groups/_groupSlug/reports/code-coverage/index.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/groups/_groupSlug/reports/code-coverage/index" */))
const _4513a1a4 = () => interopDefault(import('../pages/orgs/_provider/_owner/groups/_groupSlug/reports/code-health-trend/index.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/groups/_groupSlug/reports/code-health-trend/index" */))
const _538274f6 = () => interopDefault(import('../pages/orgs/_provider/_owner/groups/_groupSlug/reports/issue-distribution/index.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/groups/_groupSlug/reports/issue-distribution/index" */))
const _c87a6be0 = () => interopDefault(import('../pages/orgs/_provider/_owner/groups/_groupSlug/reports/issues-autofixed/index.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/groups/_groupSlug/reports/issues-autofixed/index" */))
const _217f58e2 = () => interopDefault(import('../pages/orgs/_provider/_owner/groups/_groupSlug/reports/issues-prevented/index.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/groups/_groupSlug/reports/issues-prevented/index" */))
const _4c6c1a34 = () => interopDefault(import('../pages/orgs/_provider/_owner/groups/_groupSlug/reports/misra-c/index.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/groups/_groupSlug/reports/misra-c/index" */))
const _e24aff28 = () => interopDefault(import('../pages/orgs/_provider/_owner/groups/_groupSlug/reports/owasp-top-10/index.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/groups/_groupSlug/reports/owasp-top-10/index" */))
const _36870bce = () => interopDefault(import('../pages/orgs/_provider/_owner/groups/_groupSlug/reports/public-reports/index.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/groups/_groupSlug/reports/public-reports/index" */))
const _1718018d = () => interopDefault(import('../pages/orgs/_provider/_owner/groups/_groupSlug/reports/sans-top-25/index.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/groups/_groupSlug/reports/sans-top-25/index" */))
const _d16eba2e = () => interopDefault(import('../pages/orgs/_provider/_owner/groups/_groupSlug/reports/misra-c/_tag.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/groups/_groupSlug/reports/misra-c/_tag" */))
const _46d895b1 = () => interopDefault(import('../pages/orgs/_provider/_owner/groups/_groupSlug/reports/owasp-top-10/_tag.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/groups/_groupSlug/reports/owasp-top-10/_tag" */))
const _6c45ec70 = () => interopDefault(import('../pages/orgs/_provider/_owner/groups/_groupSlug/reports/sans-top-25/_tag.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/groups/_groupSlug/reports/sans-top-25/_tag" */))
const _11005354 = () => interopDefault(import('../pages/orgs/_provider/_owner/groups/_groupSlug/repositories/index.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/groups/_groupSlug/repositories/index" */))
const _43a35e64 = () => interopDefault(import('../pages/orgs/_provider/_owner/groups/_groupSlug/settings.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/groups/_groupSlug/settings" */))
const _101127b2 = () => interopDefault(import('../pages/orgs/_provider/_owner/groups/_groupSlug/settings/general.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/groups/_groupSlug/settings/general" */))
const _8df4108e = () => interopDefault(import('../pages/orgs/_provider/_owner/groups/_groupSlug/settings/quality-gates.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/groups/_groupSlug/settings/quality-gates" */))
const _d2b1b9c6 = () => interopDefault(import('../pages/orgs/_provider/_owner/groups/_groupSlug/settings/repo-settings.vue' /* webpackChunkName: "pages/orgs/_provider/_owner/groups/_groupSlug/settings/repo-settings" */))
const _698e2d7c = () => interopDefault(import('../pages/_provider/_owner/index.vue' /* webpackChunkName: "pages/_provider/_owner/index" */))
const _826d0084 = () => interopDefault(import('../pages/_provider/_owner/_repo/index.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/index" */))
const _0966a126 = () => interopDefault(import('../pages/_provider/_owner/_repo/dependencies.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/dependencies" */))
const _4ea13030 = () => interopDefault(import('../pages/_provider/_owner/_repo/dependencies/index.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/dependencies/index" */))
const _5c215481 = () => interopDefault(import('../pages/_provider/_owner/_repo/dependencies/_target/packages/index.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/dependencies/_target/packages/index" */))
const _98689f92 = () => interopDefault(import('../pages/_provider/_owner/_repo/dependencies/_target/settings/index.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/dependencies/_target/settings/index" */))
const _37d2d448 = () => interopDefault(import('../pages/_provider/_owner/_repo/dependencies/_target/vulnerabilities/index.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/dependencies/_target/vulnerabilities/index" */))
const _0ec91a06 = () => interopDefault(import('../pages/_provider/_owner/_repo/dependencies/_target/vulnerabilities/_occurrence/index.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/dependencies/_target/vulnerabilities/_occurrence/index" */))
const _36448580 = () => interopDefault(import('../pages/_provider/_owner/_repo/history.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/history" */))
const _916bdbb8 = () => interopDefault(import('../pages/_provider/_owner/_repo/history/baseline.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/history/baseline" */))
const _93f58106 = () => interopDefault(import('../pages/_provider/_owner/_repo/history/pull-requests.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/history/pull-requests" */))
const _50b77581 = () => interopDefault(import('../pages/_provider/_owner/_repo/issues/index.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/issues/index" */))
const _8a749ba2 = () => interopDefault(import('../pages/_provider/_owner/_repo/metrics.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/metrics" */))
const _7a5dd232 = () => interopDefault(import('../pages/_provider/_owner/_repo/metrics/_metric/index.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/metrics/_metric/index" */))
const _13a2652b = () => interopDefault(import('../pages/_provider/_owner/_repo/reports.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/reports" */))
const _d23f79c6 = () => interopDefault(import('../pages/_provider/_owner/_repo/reports/active-third-party-vulnerabilities/index.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/reports/active-third-party-vulnerabilities/index" */))
const _591f822a = () => interopDefault(import('../pages/_provider/_owner/_repo/reports/code-health-trend/index.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/reports/code-health-trend/index" */))
const _de8cfee2 = () => interopDefault(import('../pages/_provider/_owner/_repo/reports/issue-distribution/index.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/reports/issue-distribution/index" */))
const _5e49e7e9 = () => interopDefault(import('../pages/_provider/_owner/_repo/reports/issues-autofixed/index.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/reports/issues-autofixed/index" */))
const _37f3128a = () => interopDefault(import('../pages/_provider/_owner/_repo/reports/issues-prevented/index.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/reports/issues-prevented/index" */))
const _e9ef578a = () => interopDefault(import('../pages/_provider/_owner/_repo/reports/misra-c/index.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/reports/misra-c/index" */))
const _16c472c5 = () => interopDefault(import('../pages/_provider/_owner/_repo/reports/owasp-top-10/index.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/reports/owasp-top-10/index" */))
const _19f33a32 = () => interopDefault(import('../pages/_provider/_owner/_repo/reports/public-reports/index.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/reports/public-reports/index" */))
const _4d2c3fd8 = () => interopDefault(import('../pages/_provider/_owner/_repo/reports/sans-top-25/index.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/reports/sans-top-25/index" */))
const _29b95767 = () => interopDefault(import('../pages/_provider/_owner/_repo/settings.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/settings" */))
const _154f0da6 = () => interopDefault(import('../pages/_provider/_owner/_repo/settings/audit-log/index.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/settings/audit-log/index" */))
const _7e84abea = () => interopDefault(import('../pages/_provider/_owner/_repo/settings/badges/index.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/settings/badges/index" */))
const _604755ba = () => interopDefault(import('../pages/_provider/_owner/_repo/settings/code-coverage/index.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/settings/code-coverage/index" */))
const _1b5a32e4 = () => interopDefault(import('../pages/_provider/_owner/_repo/settings/code-formatters/index.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/settings/code-formatters/index" */))
const _0a8bd293 = () => interopDefault(import('../pages/_provider/_owner/_repo/settings/code-review/index.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/settings/code-review/index" */))
const _3320f370 = () => interopDefault(import('../pages/_provider/_owner/_repo/settings/collaborators/index.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/settings/collaborators/index" */))
const _88fdff7a = () => interopDefault(import('../pages/_provider/_owner/_repo/settings/general/index.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/settings/general/index" */))
const _4165d1d2 = () => interopDefault(import('../pages/_provider/_owner/_repo/settings/ignore-rules/index.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/settings/ignore-rules/index" */))
const _42b4e73a = () => interopDefault(import('../pages/_provider/_owner/_repo/settings/integrations/index.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/settings/integrations/index" */))
const _705660d6 = () => interopDefault(import('../pages/_provider/_owner/_repo/settings/quality-gates/index.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/settings/quality-gates/index" */))
const _3f455476 = () => interopDefault(import('../pages/_provider/_owner/_repo/settings/integrations/jira.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/settings/integrations/jira" */))
const _ca696210 = () => interopDefault(import('../pages/_provider/_owner/_repo/settings/integrations/slack.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/settings/integrations/slack" */))
const _a5dbaf90 = () => interopDefault(import('../pages/_provider/_owner/_repo/settings/integrations/vanta.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/settings/integrations/vanta" */))

const _4296da0e = () => interopDefault(import('../pages/_provider/_owner/_repo/autofix/_autofix_id/index.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/autofix/_autofix_id/index" */))
const _4a94b94f = () => interopDefault(import('../pages/_provider/_owner/_repo/issue/_issueId.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/issue/_issueId" */))
const _6e7686ac = () => interopDefault(import('../pages/_provider/_owner/_repo/issue/_issueId/ignore-rules.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/issue/_issueId/ignore-rules" */))
const _2e158afc = () => interopDefault(import('../pages/_provider/_owner/_repo/issue/_issueId/occurrences.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/issue/_issueId/occurrences" */))
const _09784f92 = () => interopDefault(import('../pages/_provider/_owner/_repo/run/_runId/index.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/run/_runId/index" */))
const _466eb6a6 = () => interopDefault(import('../pages/_provider/_owner/_repo/run/_runId/sca/_targetId.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/run/_runId/sca/_targetId" */))
const _78203570 = () => interopDefault(import('../pages/_provider/_owner/_repo/run/_runId/sca/_targetId/index.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/run/_runId/sca/_targetId/index" */))
const _5346ca8c = () => interopDefault(import('../pages/_provider/_owner/_repo/run/_runId/sca/_targetId/_occurrenceId/index.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/run/_runId/sca/_targetId/_occurrenceId/index" */))
const _1ae33e08 = () => interopDefault(import('../pages/_provider/_owner/_repo/run/_runId/_analyzer/index.vue' /* webpackChunkName: "pages/_provider/_owner/_repo/run/_runId/_analyzer/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/autofix-installation",
    component: _4e0d484a,
    name: "autofix-installation"
  }, {
    path: "/control-panel",
    component: _e90e84be,
    name: "control-panel"
  }, {
    path: "/dashboard",
    component: _b29fe0c4,
    name: "dashboard"
  }, {
    path: "/health",
    component: _42a5efc2,
    name: "health"
  }, {
    path: "/installation",
    component: _17f16eba,
    name: "installation"
  }, {
    path: "/invitation",
    component: _ed51da7c,
    name: "invitation"
  }, {
    path: "/login",
    component: _0645ef36,
    name: "login"
  }, {
    path: "/request-access",
    component: _03a11b4b,
    name: "request-access"
  }, {
    path: "/settings",
    component: _70d47289,
    name: "settings",
    children: [{
      path: "account",
      component: _b7b00cb2,
      name: "settings-account"
    }, {
      path: "tokens",
      component: _4dc768e0,
      name: "settings-tokens"
    }, {
      path: "workspaces",
      component: _1fb2fb74,
      name: "settings-workspaces"
    }]
  }, {
    path: "/signup",
    component: _0645ef36,
    name: "signup"
  }, {
    path: "/support",
    component: _623b839c,
    name: "support"
  }, {
    path: "/team-deleted",
    component: _04a8550f,
    name: "team-deleted"
  }, {
    path: "/user-deleted",
    component: _0040497d,
    name: "user-deleted"
  }, {
    path: "/cli/auth",
    component: _499124c6,
    name: "cli-auth"
  }, {
    path: "/control-panel/license",
    component: _27eb7b5a,
    name: "control-panel-license"
  }, {
    path: "/control-panel/user-management",
    component: _96fee4d2,
    name: "control-panel-user-management"
  }, {
    path: "/ide/auth",
    component: _ddd4195a,
    name: "ide-auth"
  }, {
    path: "/installation/providers",
    component: _e5c6a81a,
    name: "installation-providers"
  }, {
    path: "/oauth/authorize",
    component: _5341c90a,
    name: "oauth-authorize"
  }, {
    path: "/onboard/bitbucket",
    component: _bae3e9ce,
    name: "onboard-bitbucket"
  }, {
    path: "/accounts/ads/login",
    component: _0fa7d58a,
    name: "accounts-ads-login"
  }, {
    path: "/accounts/bbd/login",
    component: _cb8b1e04,
    name: "accounts-bbd-login"
  }, {
    path: "/accounts/gitlab/login",
    component: _7d8ee568,
    name: "accounts-gitlab-login"
  }, {
    path: "/callback/integrations/jira",
    component: _587d69ba,
    name: "callback-integrations-jira"
  }, {
    path: "/callback/integrations/slack",
    component: _aed43b98,
    name: "callback-integrations-slack"
  }, {
    path: "/callback/integrations/vanta",
    component: _8a468918,
    name: "callback-integrations-vanta"
  }, {
    path: "/control-panel/user-management/groups",
    component: _071abfbc,
    name: "control-panel-user-management-groups"
  }, {
    path: "/control-panel/user-management/invites",
    component: _2cdf640f,
    name: "control-panel-user-management-invites"
  }, {
    path: "/team/settings/integrations/vanta",
    component: _cd0e6500,
    name: "team-settings-integrations-vanta"
  }, {
    path: "/accounts/ads/login/callback/bifrost",
    component: _05b430d4,
    meta: {"provider":"ADS","authProvider":"ads-oauth2"},
    name: "ads"
  }, {
    path: "/accounts/bitbucket_datacenter_oauth2/login/callback/bifrost",
    component: _05b430d4,
    meta: {"provider":"BITBUCKET_DATACENTER","authProvider":"bitbucket-datacenter-oauth2"},
    name: "bitbucket-datacenter"
  }, {
    path: "/accounts/bitbucket_oauth2/login/callback/bifrost",
    component: _05b430d4,
    meta: {"provider":"BITBUCKET","authProvider":"bitbucket-oauth2"},
    name: "bitbucket"
  }, {
    path: "/accounts/github-enterprise/login/callback/bifrost",
    component: _05b430d4,
    meta: {"provider":"GITHUB_ENTERPRISE","authProvider":"github-enterprise"},
    name: "github-enterprise"
  }, {
    path: "/accounts/github/login/callback/bifrost",
    component: _05b430d4,
    meta: {"provider":"GITHUB","authProvider":"github"},
    name: "github"
  }, {
    path: "/accounts/gitlab/login/callback/bifrost",
    component: _05b430d4,
    meta: {"provider":"GITLAB","authProvider":"gitlab"},
    name: "gitlab"
  }, {
    path: "/",
    component: _9121f048,
    name: "index"
  }, {
    path: "/accounts/ads/login/:login",
    component: _572b7436,
    name: "accounts-ads-login-login"
  }, {
    path: "/control-panel/user-management/groups/:groupId",
    component: _158a6d5e,
    name: "control-panel-user-management-groups-groupId"
  }, {
    path: "/control-panel/user-management/users/:userId",
    component: _5b4d5066,
    name: "control-panel-user-management-users-userId"
  }, {
    path: "/control-panel/user-management/groups/:groupId?/teams",
    component: _3c3e3c42,
    name: "control-panel-user-management-groups-groupId-teams"
  }, {
    path: "/control-panel/user-management/users/:userId?/teams",
    component: _fbfdc16c,
    name: "control-panel-user-management-users-userId-teams"
  }, {
    path: "/accounts/runner/apps/:appId/login/callback/bifrost",
    component: _05b430d4,
    meta: {"provider":"runner","authProvider":"runner"},
    name: "runner"
  }, {
    path: "/groups/invite/:inviteCode",
    component: _258eedd7,
    name: "groups-invite-inviteCode"
  }, {
    path: "/installation/:provider",
    component: _039fad64,
    name: "installation-provider"
  }, {
    path: "/invitation/:code",
    component: _3a638d3f,
    name: "invitation-code"
  }, {
    path: "/report/:reportId?",
    component: _eba907ce,
    name: "report-reportId",
    children: [{
      path: "active-third-party-vulnerabilities",
      component: _605d6b28,
      name: "report-reportId-active-third-party-vulnerabilities"
    }, {
      path: "code-coverage",
      component: _78ab685c,
      name: "report-reportId-code-coverage"
    }, {
      path: "code-health-trend",
      component: _70669dd6,
      name: "report-reportId-code-health-trend"
    }, {
      path: "issue-distribution",
      component: _67862d44,
      name: "report-reportId-issue-distribution"
    }, {
      path: "issues-autofixed",
      component: _5c89c8b8,
      name: "report-reportId-issues-autofixed"
    }, {
      path: "issues-prevented",
      component: _597345ec,
      name: "report-reportId-issues-prevented"
    }, {
      path: "misra-c",
      component: _392e7eb4,
      name: "report-reportId-misra-c"
    }, {
      path: "owasp-top-10",
      component: _2102e194,
      name: "report-reportId-owasp-top-10"
    }, {
      path: "sans-top-25",
      component: _afaf8782,
      name: "report-reportId-sans-top-25"
    }, {
      path: "sca-targets",
      component: _7aecaad0,
      name: "report-reportId-sca-targets"
    }]
  }, {
    path: "/invitation/:code/confirmation",
    component: _7cda7050,
    name: "invitation-code-confirmation"
  }, {
    path: "/onboard/:provider?/:owner?",
    component: _1f6d473e,
    name: "onboard-provider-owner",
    children: [{
      path: "invite",
      component: _b1630eb2,
      name: "onboard-provider-owner-invite"
    }, {
      path: "personal-info",
      component: _3e744eed,
      name: "onboard-provider-owner-personal-info"
    }, {
      path: "repo",
      component: _380a7210,
      name: "onboard-provider-owner-repo"
    }, {
      path: "use-cases",
      component: _fc6e9362,
      name: "onboard-provider-owner-use-cases"
    }, {
      path: ":repo?/analyzers",
      component: _7cc6f6a1,
      name: "onboard-provider-owner-repo-analyzers"
    }, {
      path: ":repo?/run",
      component: _7968669f,
      name: "onboard-provider-owner-repo-run"
    }]
  }, {
    path: "/orgs/:provider?/:owner?/members",
    component: _14fdb032,
    name: "orgs-provider-owner-members",
    children: [{
      path: "active",
      component: _71d65844,
      name: "orgs-provider-owner-members-active"
    }, {
      path: "invited",
      component: _0367c253,
      name: "orgs-provider-owner-members-invited"
    }, {
      path: "requests",
      component: _e42c54c8,
      name: "orgs-provider-owner-members-requests"
    }]
  }, {
    path: "/orgs/:provider?/:owner?/policies",
    component: _07aa9c1c,
    name: "orgs-provider-owner-policies",
    children: [{
      path: "ai",
      component: _066c53d6,
      name: "orgs-provider-owner-policies-ai"
    }, {
      path: "dynamic-risk",
      component: _40381cca,
      name: "orgs-provider-owner-policies-dynamic-risk"
    }, {
      path: "license-compliance",
      component: _ba5e04d8,
      name: "orgs-provider-owner-policies-license-compliance"
    }, {
      path: "sca-vulnerabilities",
      component: _74328d41,
      name: "orgs-provider-owner-policies-sca-vulnerabilities"
    }]
  }, {
    path: "/orgs/:provider?/:owner?/reports",
    component: _d76024e6,
    name: "orgs-provider-owner-reports",
    children: [{
      path: "active-third-party-vulnerabilities",
      component: _d46bde0a,
      name: "orgs-provider-owner-reports-active-third-party-vulnerabilities"
    }, {
      path: "code-coverage",
      component: _dbff476e,
      name: "orgs-provider-owner-reports-code-coverage"
    }, {
      path: "code-health-trend",
      component: _bef97d66,
      name: "orgs-provider-owner-reports-code-health-trend"
    }, {
      path: "issue-distribution",
      component: _6606ca6d,
      name: "orgs-provider-owner-reports-issue-distribution"
    }, {
      path: "issues-autofixed",
      component: _9107dd72,
      name: "orgs-provider-owner-reports-issues-autofixed"
    }, {
      path: "issues-prevented",
      component: _3d38a019,
      name: "orgs-provider-owner-reports-issues-prevented"
    }, {
      path: "misra-c",
      component: _6132edc6,
      name: "orgs-provider-owner-reports-misra-c"
    }, {
      path: "owasp-top-10",
      component: _1acdfb23,
      name: "orgs-provider-owner-reports-owasp-top-10"
    }, {
      path: "public-reports",
      component: _41bc2310,
      name: "orgs-provider-owner-reports-public-reports"
    }, {
      path: "sans-top-25",
      component: _b0025814,
      name: "orgs-provider-owner-reports-sans-top-25"
    }, {
      path: "sca-targets",
      component: _3ba051c7,
      name: "orgs-provider-owner-reports-sca-targets"
    }, {
      path: "misra-c/:tag?",
      component: _d97f9a40,
      name: "orgs-provider-owner-reports-misra-c-tag"
    }, {
      path: "owasp-top-10/:tag?",
      component: _50812fcc,
      name: "orgs-provider-owner-reports-owasp-top-10-tag"
    }, {
      path: "sans-top-25/:tag?",
      component: _fd12ae32,
      name: "orgs-provider-owner-reports-sans-top-25-tag"
    }]
  }, {
    path: "/orgs/:provider?/:owner?/repos",
    component: _6fb3d38f,
    children: [{
      path: "",
      component: _00b132d2,
      name: "orgs-provider-owner-repos"
    }, {
      path: "groups",
      component: _39097f04,
      name: "orgs-provider-owner-repos-groups"
    }, {
      path: ":repoType",
      component: _8d5b6eaa,
      name: "orgs-provider-owner-repos-repoType"
    }]
  }, {
    path: "/orgs/:provider?/:owner?/settings",
    component: _82864976,
    name: "orgs-provider-owner-settings",
    children: [{
      path: "access",
      component: _0ea2121e,
      name: "orgs-provider-owner-settings-access"
    }, {
      path: "audit-log",
      component: _82eefef0,
      name: "orgs-provider-owner-settings-audit-log"
    }, {
      path: "billing",
      component: _efa83518,
      name: "orgs-provider-owner-settings-billing"
    }, {
      path: "general",
      component: _3a2b8f9e,
      name: "orgs-provider-owner-settings-general"
    }, {
      path: "integrations",
      component: _80472ac8,
      name: "orgs-provider-owner-settings-integrations"
    }, {
      path: "security",
      component: _34dbf50c,
      name: "orgs-provider-owner-settings-security"
    }, {
      path: "usage",
      component: _6e88d89a,
      name: "orgs-provider-owner-settings-usage"
    }, {
      path: "webhooks",
      component: _7ea73916,
      children: [{
        path: "",
        component: _efa3d1ce,
        name: "orgs-provider-owner-settings-webhooks"
      }, {
        path: ":webhookId",
        component: _1b2003bf,
        name: "orgs-provider-owner-settings-webhooks-webhookId"
      }, {
        path: ":webhookId/log/:logId?",
        component: _b07aaee4,
        name: "orgs-provider-owner-settings-webhooks-webhookId-log-logId"
      }]
    }, {
      path: "billing/checkout",
      component: _9aae54d8,
      name: "orgs-provider-owner-settings-billing-checkout"
    }, {
      path: "integrations/jira",
      component: _434edcd4,
      name: "orgs-provider-owner-settings-integrations-jira"
    }, {
      path: "integrations/slack",
      component: _17f2d25a,
      name: "orgs-provider-owner-settings-integrations-slack"
    }, {
      path: "integrations/vanta",
      component: _2a39ab9a,
      name: "orgs-provider-owner-settings-integrations-vanta"
    }, {
      path: "usage/targets",
      component: _63610cca,
      name: "orgs-provider-owner-settings-usage-targets"
    }, {
      path: "billing/subscribe/:plan?",
      component: _12fc82b6,
      name: "orgs-provider-owner-settings-billing-subscribe-plan"
    }]
  }, {
    path: "/orgs/:provider?/:owner?/groups/:groupSlug?",
    component: _69e7c834,
    children: [{
      path: "",
      component: _5cfb5092,
      name: "orgs-provider-owner-groups-groupSlug"
    }, {
      path: "reports",
      component: _5b8522e4,
      name: "orgs-provider-owner-groups-groupSlug-reports",
      children: [{
        path: "code-coverage",
        component: _c0f6ffc0,
        name: "orgs-provider-owner-groups-groupSlug-reports-code-coverage"
      }, {
        path: "code-health-trend",
        component: _4513a1a4,
        name: "orgs-provider-owner-groups-groupSlug-reports-code-health-trend"
      }, {
        path: "issue-distribution",
        component: _538274f6,
        name: "orgs-provider-owner-groups-groupSlug-reports-issue-distribution"
      }, {
        path: "issues-autofixed",
        component: _c87a6be0,
        name: "orgs-provider-owner-groups-groupSlug-reports-issues-autofixed"
      }, {
        path: "issues-prevented",
        component: _217f58e2,
        name: "orgs-provider-owner-groups-groupSlug-reports-issues-prevented"
      }, {
        path: "misra-c",
        component: _4c6c1a34,
        name: "orgs-provider-owner-groups-groupSlug-reports-misra-c"
      }, {
        path: "owasp-top-10",
        component: _e24aff28,
        name: "orgs-provider-owner-groups-groupSlug-reports-owasp-top-10"
      }, {
        path: "public-reports",
        component: _36870bce,
        name: "orgs-provider-owner-groups-groupSlug-reports-public-reports"
      }, {
        path: "sans-top-25",
        component: _1718018d,
        name: "orgs-provider-owner-groups-groupSlug-reports-sans-top-25"
      }, {
        path: "misra-c/:tag?",
        component: _d16eba2e,
        name: "orgs-provider-owner-groups-groupSlug-reports-misra-c-tag"
      }, {
        path: "owasp-top-10/:tag?",
        component: _46d895b1,
        name: "orgs-provider-owner-groups-groupSlug-reports-owasp-top-10-tag"
      }, {
        path: "sans-top-25/:tag?",
        component: _6c45ec70,
        name: "orgs-provider-owner-groups-groupSlug-reports-sans-top-25-tag"
      }]
    }, {
      path: "repositories",
      component: _11005354,
      name: "orgs-provider-owner-groups-groupSlug-repositories"
    }, {
      path: "settings",
      component: _43a35e64,
      name: "orgs-provider-owner-groups-groupSlug-settings",
      children: [{
        path: "general",
        component: _101127b2,
        name: "orgs-provider-owner-groups-groupSlug-settings-general"
      }, {
        path: "quality-gates",
        component: _8df4108e,
        name: "orgs-provider-owner-groups-groupSlug-settings-quality-gates"
      }, {
        path: "repo-settings",
        component: _d2b1b9c6,
        name: "orgs-provider-owner-groups-groupSlug-settings-repo-settings"
      }]
    }]
  }, {
    path: "/:provider/:owner",
    component: _698e2d7c,
    name: "provider-owner"
  }, {
    path: "/:provider/:owner?/:repo",
    component: _826d0084,
    name: "provider-owner-repo"
  }, {
    path: "/:provider/:owner?/:repo/dependencies",
    component: _0966a126,
    children: [{
      path: "",
      component: _4ea13030,
      name: "provider-owner-repo-dependencies"
    }, {
      path: ":target/packages",
      component: _5c215481,
      name: "provider-owner-repo-dependencies-target-packages"
    }, {
      path: ":target/settings",
      component: _98689f92,
      name: "provider-owner-repo-dependencies-target-settings"
    }, {
      path: ":target/vulnerabilities",
      component: _37d2d448,
      name: "provider-owner-repo-dependencies-target-vulnerabilities"
    }, {
      path: ":target/vulnerabilities/:occurrence",
      component: _0ec91a06,
      name: "provider-owner-repo-dependencies-target-vulnerabilities-occurrence"
    }]
  }, {
    path: "/:provider/:owner?/:repo/history",
    component: _36448580,
    name: "provider-owner-repo-history",
    children: [{
      path: "baseline",
      component: _916bdbb8,
      name: "provider-owner-repo-history-baseline"
    }, {
      path: "pull-requests",
      component: _93f58106,
      name: "provider-owner-repo-history-pull-requests"
    }]
  }, {
    path: "/:provider/:owner?/:repo/issues",
    component: _50b77581,
    name: "provider-owner-repo-issues"
  }, {
    path: "/:provider/:owner?/:repo/metrics",
    component: _8a749ba2,
    name: "provider-owner-repo-metrics",
    children: [{
      path: ":metric",
      component: _7a5dd232,
      name: "provider-owner-repo-metrics-metric"
    }]
  }, {
    path: "/:provider/:owner?/:repo/reports",
    component: _13a2652b,
    name: "provider-owner-repo-reports",
    children: [{
      path: "active-third-party-vulnerabilities",
      component: _d23f79c6,
      name: "provider-owner-repo-reports-active-third-party-vulnerabilities"
    }, {
      path: "code-health-trend",
      component: _591f822a,
      name: "provider-owner-repo-reports-code-health-trend"
    }, {
      path: "issue-distribution",
      component: _de8cfee2,
      name: "provider-owner-repo-reports-issue-distribution"
    }, {
      path: "issues-autofixed",
      component: _5e49e7e9,
      name: "provider-owner-repo-reports-issues-autofixed"
    }, {
      path: "issues-prevented",
      component: _37f3128a,
      name: "provider-owner-repo-reports-issues-prevented"
    }, {
      path: "misra-c",
      component: _e9ef578a,
      name: "provider-owner-repo-reports-misra-c"
    }, {
      path: "owasp-top-10",
      component: _16c472c5,
      name: "provider-owner-repo-reports-owasp-top-10"
    }, {
      path: "public-reports",
      component: _19f33a32,
      name: "provider-owner-repo-reports-public-reports"
    }, {
      path: "sans-top-25",
      component: _4d2c3fd8,
      name: "provider-owner-repo-reports-sans-top-25"
    }]
  }, {
    path: "/:provider/:owner?/:repo/settings",
    component: _29b95767,
    name: "provider-owner-repo-settings",
    children: [{
      path: "audit-log",
      component: _154f0da6,
      name: "provider-owner-repo-settings-audit-log"
    }, {
      path: "badges",
      component: _7e84abea,
      name: "provider-owner-repo-settings-badges"
    }, {
      path: "code-coverage",
      component: _604755ba,
      name: "provider-owner-repo-settings-code-coverage"
    }, {
      path: "code-formatters",
      component: _1b5a32e4,
      name: "provider-owner-repo-settings-code-formatters"
    }, {
      path: "code-review",
      component: _0a8bd293,
      name: "provider-owner-repo-settings-code-review"
    }, {
      path: "collaborators",
      component: _3320f370,
      name: "provider-owner-repo-settings-collaborators"
    }, {
      path: "general",
      component: _88fdff7a,
      name: "provider-owner-repo-settings-general"
    }, {
      path: "ignore-rules",
      component: _4165d1d2,
      name: "provider-owner-repo-settings-ignore-rules"
    }, {
      path: "integrations",
      component: _42b4e73a,
      name: "provider-owner-repo-settings-integrations"
    }, {
      path: "quality-gates",
      component: _705660d6,
      name: "provider-owner-repo-settings-quality-gates"
    }, {
      path: "integrations/jira",
      component: _3f455476,
      name: "provider-owner-repo-settings-integrations-jira"
    }, {
      path: "integrations/slack",
      component: _ca696210,
      name: "provider-owner-repo-settings-integrations-slack"
    }, {
      path: "integrations/vanta",
      component: _a5dbaf90,
      name: "provider-owner-repo-settings-integrations-vanta"
    }]
  }, {
    path: "/:provider/:owner/:repo/settings/repo-members",
    redirect: {"name":"provider-owner-repo-settings-collaborators"}
  }, {
    path: "/:provider/:owner/:repo/settings/reporting",
    redirect: {"name":"provider-owner-repo-settings-quality-gates"}
  }, {
    path: "/:provider/:owner?/:repo/autofix/:autofix_id",
    component: _4296da0e,
    name: "provider-owner-repo-autofix-autofix_id"
  }, {
    path: "/:provider/:owner?/:repo/issue/:issueId?",
    component: _4a94b94f,
    name: "provider-owner-repo-issue-issueId",
    children: [{
      path: "ignore-rules",
      component: _6e7686ac,
      name: "provider-owner-repo-issue-issueId-ignore-rules"
    }, {
      path: "occurrences",
      component: _2e158afc,
      name: "provider-owner-repo-issue-issueId-occurrences"
    }]
  }, {
    path: "/:provider/:owner?/:repo/run/:runId",
    component: _09784f92,
    name: "provider-owner-repo-run-runId"
  }, {
    path: "/:provider/:owner?/:repo/run/:runId?/sca/:targetId?",
    component: _466eb6a6,
    children: [{
      path: "",
      component: _78203570,
      name: "provider-owner-repo-run-runId-sca-targetId"
    }, {
      path: ":occurrenceId",
      component: _5346ca8c,
      name: "provider-owner-repo-run-runId-sca-targetId-occurrenceId"
    }]
  }, {
    path: "/:provider/:owner?/:repo/run/:runId?/:analyzer",
    component: _1ae33e08,
    name: "provider-owner-repo-run-runId-analyzer"
  }, {
    path: "/:provider/:owner/:repo/run/:runId/:analyzer/:issueId",
    redirect: (to) => ({
          name: 'provider-owner-repo-run-runId-analyzer',
          params: {
            provider: to.params.provider,
            owner: to.params.owner,
            repo: to.params.repo,
            runId: to.params.runId,
            analyzer: to.params.analyzer
          },
          hash: `#${to.params.issueId}`
        })
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
